import React, { ReactNode, useContext, useEffect, useState } from 'react'

import { Box, CircularProgress } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

import { UserContext } from '../../user'
import { APP_PATHS } from '../paths'

export const OnboardingGuard: React.FC<{ children: ReactNode }> = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { currentUser, isOnboadringCompleted } = useContext(UserContext)

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)

    if (currentUser) {
      if (isOnboadringCompleted) {
        navigate(APP_PATHS.dashboard)
      } else if (!currentUser) {
        navigate(APP_PATHS.auth)
      }
    }

    setIsLoading(false)
  }, [location, currentUser, isOnboadringCompleted, navigate])

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    )
  }

  return <>{children}</>
}
